/*
 * @Descripttion:
 * @Author: huangqiang
 * @version:
 * @Date: 2023-02-08 19:47:07
 * @LastEditors: huangqiang
 * @LastEditTime: 2023-03-17 10:04:54
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/common/css/reset.css'
import 'lib-flexible'
import { Toast } from 'vant'
// 图片预览
import hevueImgPreview from 'hevue-img-preview'
Vue.use(hevueImgPreview)
Vue.use(Toast)
Vue.config.productionTip = false

// 设置修改页面标题的自定义指令
Vue.directive('title', {
  inserted: function (el) {
    document.title = el.getAttribute('title')
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
